const SELECTOR = '.js-media-and-product-info-slider';

const hasSlick = () =>
  !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick);

const initSlider = (slider) => {
  if (!slider || slider.classList.contains('slick-initialized')) return;
  if (!hasSlick()) return;

  const slideCount = slider.querySelectorAll('.media_and_product_info__slide').length;
  if (slideCount <= 1) return;

  window.jQuery(slider).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    adaptiveHeight: true,
    dotsClass: 'media_and_product_info__dots slick-dots',
  });
};

const unloadSlider = (slider) => {
  if (!slider || !slider.classList.contains('slick-initialized')) return;
  if (!hasSlick()) return;
  window.jQuery(slider).slick('unslick');
};

const initAll = (root = document) => {
  root.querySelectorAll(SELECTOR).forEach(initSlider);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach(unloadSlider);
  });
}

